import { createGuestApiAxiosClient } from "@/shared/axios/axios";
import {
  UserLanguage,
  type RegistrationRequest,
} from "@/shared/generated/ExpHubGuestApi";
import { handleAxiosError } from "@/shared/helper/handleAxiosError.helper";
import type { RegistrationData } from "@/app/registration-app/user/shared/@types/RegistrationData";

export const serializeDataForRegisterUser = ({
  captcha,
  customerId,
  firstName,
  lastName,
  salutation,
  phoneNumber,
  documentId,
  email,
  channel,
}: RegistrationData): RegistrationRequest => ({
  captcha,
  channel,
  ERPCustomerId: customerId,
  name1: firstName,
  name2: lastName,
  salutation,
  telephoneNumber: phoneNumber,
  referenceNumber: documentId,
  email,
  language: UserLanguage.De,
});

export const registerUser = async (data: RegistrationRequest) => {
  const channel = data.channel.toLowerCase();
  try {
    const client = await createGuestApiAxiosClient();
    await client.post(`/${channel}/registrations`, data);
  } catch (error) {
    throw handleAxiosError(error);
  }
};
